<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Thematiques</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="#">Acceuil</a></li>
                    <li class="breadcrumb-item active">Thematiques</li>
                </ol>
            </div>
        </div>
    </div>
    <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
   <div class="main-card mb-3 card">
    <div class="card-header  align-items-end">
        <p class="card-header-title font-size-lg text-capitalize fw-normal">Liste des Thématiques</p>
        
            <button class="btn-shadow btn btn-success" (click)="createThematique()">Nouvelle Thématique</button>
        
    </div>
    <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
            class="align-middle text-truncate mb-0 table table-borderless table-hover table table-striped">
            <thead>
                <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">Logo</th>
                    <th class="text-center">Nom</th>
                    <th class="text-center">Couleur</th>
                    <th class="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let thematique of thematiques">
                    <td class="text-center text-muted" style="width: 80px;">#{{ thematique.id }}</td>
                    <td class="text-center" style="width: 80px;">
                        <img width="40" class="rounded-circle" src="{{ environment.apiUrl+thematique.image_src }}"
                            alt="">
                    </td>
                    <td class="text-center"><a [routerLink]="">{{ thematique.nom }}</a></td>
                    <td class="text-center"><a [routerLink]="">{{ thematique.color }}</a></td>
                   
                    <td class="text-center">
                        <div role="group" class="btn-group-sm btn-group">
                            <button class="btn-shadow btn btn-success" (click)="viewThematique(thematique)">Voir </button>
                            <button  class="btn-shadow btn btn-primary"
                                (click)="editThematique(thematique)">Editer</button>
                            <button  class="btn-shadow btn btn-danger"
                               (click)="deleteThematique(thematique.id)" >Supprimer</button>
                        </div>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>

</div>
</section>
<!-- /.content -->